var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '@emotion/styled';
import { getTrackerProps } from '../../../common/tracking/getTrackerProps';
import { breakpoint, boxShadow } from '../../../common/theme/helper';
import { Button } from '../../../common/components/Button';
import burgerIcon from '../../../common/assets/icons/burger-icon.svg';
var MenuButtonContainer = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", ";\n  ", ";\n\n  margin-right: 12px;\n\n  ", " {\n    display: none;\n  }\n"], ["\n  border-radius: ", ";\n  ", ";\n\n  margin-right: 12px;\n\n  ", " {\n    display: none;\n  }\n"])), function (props) { return (props.theme.isHome24 ? '3px' : 0); }, boxShadow(0), breakpoint(1));
MenuButtonContainer.defaultProps = {
    kind: 'bare',
};
var BurgerIcon = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 40px;\n  max-width: 40px;\n  height: 40px;\n  max-height: 40px;\n"], ["\n  width: 40px;\n  max-width: 40px;\n  height: 40px;\n  max-height: 40px;\n"])));
var MenuButton = function (_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    return (React.createElement(MenuButtonContainer, __assign({}, getTrackerProps(__assign({ 'data-testid': 'hamburger-button', 'aria-label': 'menu', onClick: onClick }, props), {
        event: 'navigation',
        eventCategory: 'icon',
        eventData: { placement: 'header', iconIdentifier: 'hamburgerIcon' },
    })),
        React.createElement(BurgerIcon, { src: burgerIcon, alt: "", title: "", "data-testid": "hamburger-button-icon", "aria-hidden": "true" })));
};
export default MenuButton;
var templateObject_1, templateObject_2;
